<template>
  <s-sign-call-back-view />
</template>
<script>
import SSignCallBackView from '@/components/SSignCallBackView'
import { getStorage } from '../utils/storageUtil'
import { globalModule } from '../store/moduleName'
import bwWorkflowApi from '@/api/workflow/bwWorkflow'
import { BW_SIGN_STATUS, LOCAL_STORAGE_KEY } from '@/constant/constant'
import { isArrayEmptyOrNull } from '@/utils/arrayUtil'

const WAIT_FOR_CHECKING_SINGING_CART = 1 * 1000

export default {
  components: {
    SSignCallBackView
  },
  data: () => {
    return {
      overdueRecordCodes: []
    }
  },
  async mounted () {
    if (!this.$route.query['error']) {
      let eSignOAuthCode = this.$route.query['code']
      let bizCode = getStorage(LOCAL_STORAGE_KEY.G2E_BIZ_CODE)
      let signBatchId = ''
      await bwWorkflowApi.batchSign(resp => {
        if (resp.status === 201 || resp.status === 200) {
          signBatchId = resp.data.data.batch_no
          this.overdueRecordCodes = resp.data.data.overdue_record_codes
        } else if (resp.status === 400) {
          // replace by global http error handler
        } else {
          this.$store.dispatch(globalModule + '/setErrorMessage', this.$t(getStorage('g2e-failMessageKey')))
        }
      }, eSignOAuthCode, bizCode)

      if (signBatchId) {
        this.waitForSigningJobComplete(signBatchId)
      } else {
        this.$router.push(getStorage('g2e-redirectPath'))
      }
    } else {
      this.$store.dispatch(globalModule + '/setErrorMessage', this.$t(getStorage('g2e-failMessageKey')))
      this.$router.push(getStorage('g2e-redirectPath'))
    }
  },
  methods: {
    isSigning (jobs) {
      let found = jobs.find(job => ((job.stat === BW_SIGN_STATUS.WAITING) || (job.stat === BW_SIGN_STATUS.SIGNING)))
      if (found) { return true } else { return false }
    },
    isFail (jobs) {
      let found = jobs.find(job => (job.stat === BW_SIGN_STATUS.FAIL))
      if (found) { return true } else { return false }
    },
    waitForSigningJobComplete (batchId) {
      let signing = false
      bwWorkflowApi.getCartByBatchNo(resp => {
        if (resp.status === 201 || resp.status === 200) {
          if (this.isSigning(resp.data.data)) {
            signing = true
            setTimeout(() => { this.waitForSigningJobComplete(batchId) }, WAIT_FOR_CHECKING_SINGING_CART)
          } else {
            let overdueMsg = ''
            if (!isArrayEmptyOrNull(this.overdueRecordCodes)) {
              overdueMsg = '<br>' + this.$t('Workflow.OT.ProposalOverdue', [this.overdueRecordCodes.join()])
            }
            if (this.isFail(resp.data.data)) {
              this.$store.dispatch(globalModule + '/setErrorMessage', this.$t(getStorage('g2e-failMessageKey')) + overdueMsg)
            } else {
              this.$store.dispatch(globalModule + '/setErrorMessage', this.$t(getStorage('g2e-successMessageKey')) + overdueMsg)
            }
          }
        } else {
          this.$store.dispatch(globalModule + '/setErrorMessage', this.$t(getStorage('g2e-failMessageKey')))
        }
        if (!signing) {
          this.$router.push(getStorage('g2e-redirectPath'))
        }
      }, batchId)
    }
  }
}
</script>
